import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useEffect } from 'react'
import { kebabCase } from 'lodash'
import { autorun } from 'mobx'

export const FeatureFlagAttributes = observer(() => {
  const featureFlags = useRootStore().featureFlags
  const flags = featureFlags.flags()

  useEffect(() => {
    const disposer = autorun(() => {
      for (const [flag, enabled] of flags.entries()) {
        if (flag === 'onboarding_redesign') continue

        document.documentElement.setAttribute(`data-ff-${kebabCase(flag)}`, enabled ? 'on' : 'off')
      }
    })

    return () => {
      disposer()
    }
  }, [flags])

  return null
})
